export const SHOPIFY_CART_ID = 'olea-shopify-cart-id';
export const LOGOUT = 'logout';
export const DISCOVER_TUTORIAL = 'discover_tutorial_complete';
export const DISCOVERY_SWIPES = 'discovery_swipes';
export const DISCOVERY_LAST_INTERACTION_DATE = 'last_interaction_date';
export const DISCOVERY_LAST_UNLOCK = 'last_unlock';
export const SCAN_TUTORIAL = 'scan_artwork_tutorial_complete';
